import generateUUID from '../../../_utils/math/generateUUID'
import Geometry from './Geometry'
import InstancedAttribute from './InstancedAttribute';

export default class InstancedGeometry extends Geometry {
  constructor() {
    super();
    this._ext = null;
    this.numInstances = 1;
  }

  addAttribute(name, attribute) {
    this.attributes[name] = attribute;
  }

  removeAttribute(name) {
    this.attributes[name] = null;
    delete this.attributes[name];
  }

  setIndex(index) {
    this.index = index;
  }

  removeIndex() {
    this.index = null;
  }

  enableAttributes(glProgram) {
    this._attrLocations = {};
    let attribute, attrLocation;
    for(let name in this.attributes) {
      attribute = this.attributes[name];

      attrLocation = this._gl.getAttribLocation(glProgram, name);
      if(attrLocation == -1) continue;

      this._attrLocations[name] = attrLocation;

      this._gl.bindBuffer(this._gl.ARRAY_BUFFER, this._glBuffers[name]);
      this._gl.enableVertexAttribArray(attrLocation);
      this._gl.vertexAttribPointer(attrLocation, attribute.itemSize, this._gl.FLOAT, false, 0, 0);

      this._ext.vertexAttribDivisorANGLE(attrLocation, attribute.divisor || 0);
    }

    // index
    if(this.index) {
      this._gl.bindBuffer(this._gl.ELEMENT_ARRAY_BUFFER,  this._glIndexBuffer);
    }
  }

  drawGeometry() {
    if(this.index) {
      this._ext.drawElementsInstancedANGLE(this._gl.TRIANGLES, this.index.count, this._gl.UNSIGNED_SHORT, 0, this.numInstances);
      this._gl.bindBuffer(this._gl.ELEMENT_ARRAY_BUFFER, this._glIndexBuffer);
    } else {
      this._ext.drawArraysInstancedANGLE(this._gl.TRIANGLES, 0, 3, this.numInstances);
    }
  }

  setExt(ext = null) {
    if(this._ext) return;
    if(ext === null) {
      this._ext = this._gl.getExtension('ANGLE_instanced_arrays');
    } else {
      this._ext = ext;
    }

    if(this._ext == null){
      throw new Error('ANGLE_instanced_arrays not supported');
    }
  }

  setGLContext(gl) {
    super.setGLContext(gl);
    this.setExt(this._ext);
  }

  _disableAttrLocation(attrLocation) {
    this._gl.disableVertexAttribArray(attrLocation);
    this._ext.vertexAttribDivisorANGLE(attrLocation, 0);
  }
}
